// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"Add_style_clearfix__l3QSX","tableBox":"Add_style_tableBox__1y_wL"};